/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportVersionContentPreviewDTO
 */
export interface ReportVersionContentPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof ReportVersionContentPreviewDTO
     */
    reportName: string;
}

/**
 * Check if a given object implements the ReportVersionContentPreviewDTO interface.
 */
export function instanceOfReportVersionContentPreviewDTO(value: object): value is ReportVersionContentPreviewDTO {
    if (!('reportName' in value) || value['reportName'] === undefined) return false;
    return true;
}

export function ReportVersionContentPreviewDTOFromJSON(json: any): ReportVersionContentPreviewDTO {
    return ReportVersionContentPreviewDTOFromJSONTyped(json, false);
}

export function ReportVersionContentPreviewDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportVersionContentPreviewDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'reportName': json['reportName'],
    };
}

export function ReportVersionContentPreviewDTOToJSON(value?: ReportVersionContentPreviewDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reportName': value['reportName'],
    };
}

